var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.npsRating !== null)?_c('div',{staticClass:"columns is-pulled-right nps-component"},[_c('div',{staticClass:"column is-1",class:_vm.npsCat},[_vm._v("\n    "+_vm._s(_vm.npsRating)+"/10\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80b04fe4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NPSScore.vue
// module id = null
// module chunks = 